<!-- Sample Usage:
<script>
	import Tab1 from "./Tab1.svelte";
	import Tab2 from "./Tab2.svelte";
	import Tab3 from "./Tab3.svelte";
  import Tabs from "./Tabs.svelte";

  // List of tab items with labels, values and assigned components
  let items = [
    { label: "Tab 1 label",
		 value: 1,
		 component: Tab1,
     props: props
		},
    { label: "Tab 2 label",
		 value: 2,
		 component: Tab2,
     props: props
		},
    { label: "Tab 3 label",
		 value: 3,
		 component: Tab3
     props: props
		}
  ];
</script>

<Tabs {items} /> 
-->

<script>
  export let items = [];
  export let activeTabValue = 1;

  const handleClick = (tabValue) => () => (activeTabValue = tabValue);
</script>

<style>
  .box {
    margin-bottom: 10px;
    padding: 24px 0;
  }

  ul {
    display: flex;
    flex-wrap: wrap;
    padding-left: 0;
    margin-bottom: 0;
    list-style: none;
    gap: 24px;
  }

  li {
    margin-bottom: -1px;
  }

  span {
    border-bottom: 3px solid transparent;
    display: block;
    padding: 0 1rem 12px;
    cursor: pointer;
    font-weight: 500;
    font-size: 14px;
    color: #7f7f7f;
    transition: color 200ms;

    &:hover {
      color: #000;
    }
  }

  li.active > span {
    color: #000;
    border-bottom-color: #896bd9;
  }
</style>

<ul>
  {#each items as item}
    <li class={activeTabValue === item.value ? 'active' : ''}>
      <span on:click={handleClick(item.value)}>{item.label}</span>
    </li>
  {/each}
</ul>
{#each items as item}
  {#if activeTabValue == item.value}
    <div class="box">
      <svelte:component this={item.component} props={item.props} />
    </div>
  {/if}
{/each}
